export default __webpack_public_path__ + "static/media/myb-travel.fa8181f2.jpg";